import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UnlinkBusinessRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { UnlinkBusinessResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const unlinkBusiness = (request: UnlinkBusinessRequest, options?: CashRequestOptions) =>
  post<UnlinkBusinessRequest, UnlinkBusinessResponse>('/2.0/cash/unlink-business', request, {
    ...options,
    rejectOnError: true,
  })
